import { RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { LoadingComponent } from './components/loading/loading.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoadingComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.less',
    standalone: true,
})
export class AppComponent {
    title = 'team-page-app';
}
